<template>
  <div class="baseContent-warp">
    <Card class="menu-card">
      <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1">会员管理</el-menu-item>
        <el-menu-item index="2">充值管理</el-menu-item>
      </el-menu>
      <div slot="content">
        <MemberList v-if="menuIndex === '1'" />
        <MemberRecharge v-if="menuIndex === '2'" />
      </div>
    </Card>
  </div>
</template>

<script lang="js">
export default {
  components: {
    MemberList: () => import("./components/MemberList.vue"), // 会员管理
    MemberRecharge: () => import("./components/MemberRecharge.vue"), // 充值管理
  },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('memberListPage')
    if (index) this.activeIndex = this.menuIndex = index
  },
  methods: {
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key
      this.$session.set('memberListPage', key)
    }
  }
};
</script>